import { Dispatch } from 'redux';

import EApiMiddlewareMethod from 'config/redux/middlewares/api.middleware.enum';
import EBinDiscountBannerTypes from './binDiscountBanner.type';
import { BIN_DISCOUNT_BANNER } from '../../../pages/Checkout/constants/apis.constant';
import { IAppState } from 'config/redux/reducers';

import { IBinDiscountBannerState } from './binDiscountBanner.reducer';

export const fetchBinDiscountBanners = () => (dispatch: Dispatch, getState: () => IAppState) => {
  const { areaCode = '' } = getState().appConfig;
  dispatch({
    type: EBinDiscountBannerTypes.BIN_DISCOUNT_BANNER_SET_DATA,
    payload: {
      method: EApiMiddlewareMethod.GET,
      url: BIN_DISCOUNT_BANNER,
      params: {
        areacode: areaCode,
      },
      onSuccess: (response: IBinDiscountBannerState) => {
        dispatch(setBinDiscountBannerData(response));
      },
      onFailure: () => {
        dispatch(
          setBinDiscountBannerData({
            data: [],
          })
        );
      },
    },
  });
};

export const setBinDiscountBannerData = (payload: IBinDiscountBannerState | null) => ({
  type: EBinDiscountBannerTypes.BIN_DISCOUNT_BANNER_SET_DATA_SUCCESS,
  payload,
});
